import React from 'react';
import { Notification } from '../../../Components/Notification';
import { SupportLink } from '../../../Components/SupportLink';
import { AppView } from '../../../graphQL';

export const DuplicateEmailMessage = ({ appView }: { appView: AppView }) => {
  if (appView === AppView.Mcp) {
    return (
      <Notification kind="negative">
        Booking incomplete: The student you are attempting to refer has been in care with Mantra
        previously. Please <SupportLink /> to determine eligibility for care reactivation for this
        student.
      </Notification>
    );
  }

  return (
    <Notification kind="negative">Referral not completed: Existing student account.</Notification>
  );
};
